module.exports = __webpack_public_path__ + "static/the-opposite-of-loneliness-caf021eaf3829e31c4fc95ab4d14ae02.jpg";